import Module from '../module';

class PrudenceFoundation extends Module {

	constructor(options?: {
		cssId: {},
		slug: string
	}) {
		super('Home Prudence Foundation Module');
	}

	startup() {
		this.msg('startup');
	}

	bind() {
		this.msg('bind');
	}
}

export default PrudenceFoundation;